import i18n from "i18n-js";

import { es, es_AR, es_BO, es_CL, es_EC, es_ES, es_MX, es_PE, es_PY, es_UY } from "./locale/es";

i18n.fallbacks = true;
i18n.defaultLocale = "es";
i18n.translations = { es, es_AR, es_BO, es_CL, es_EC, es_ES, es_MX, es_PE, es_PY, es_UY };

const getI18n = (lang) => {
    i18n.locale = lang;
    return i18n;
};
export default getI18n;

export const DATE_FORMAT = "YYYY-MM-DD";
export const DATETIME_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_DDMMYYYY = "DD/MM/YYYY";
